import type { BuildingTechnicalSystemsSections } from "../../../types/buildings-sections/technical-systems";

export const technicalSystems: BuildingTechnicalSystemsSections = {
  title: "Technical Systems",
  description: "Building technical systems and equipment management",
  type: "Type",
  location: "Location",
  manufacturer: "Manufacturer",
  model: "Model",
  lastMaintenanceDate: "Last Maintenance Date",
  capacity: "Capacity",
  addSystem: "Add System",
  selectType: "Select System Type",
  noDataAvailable: "Technical systems data not available",
  addedSuccessfully: "Technical system added successfully",
  deletedSuccessfully: "Technical system deleted successfully",
  addError: "Failed to add technical system",
  creatingRecord: "Creating technical systems record...",
  systemType: "System Type",
  installationDate: "Installation Date",
  installationYear: "Installation Year",
  userManualLink: "User Manual Link",
  warrantyInfo: "Warranty Info",
  maintenanceRequirements: "Maintenance Requirements",
  expectedLifetime: "Expected Lifetime",
  systemTypes: {
    hvac: "HVAC",
    electrical: "Electrical System",
    plumbing: "Plumbing System",
    fire: "Fire Protection",
    security: "Security",
    automation: "Building Automation",
    elevator: "Elevator",
    communication: "Communication",
    electricalSystem: "Electrical System",
    waterSystem: "Water System",
    sewerSystem: "Sewer System",
    heatingSystem: "Heating System",
    ventilationSystem: "Ventilation System",
    coolingSystem: "Cooling System",
    gasSystem: "Gas System",
  },
};
